import { bodyPart } from '../../../../constants/bodyPart';
import { gameImportType } from '../../../../constants/gameImportType';
import { actorType } from '../../../../constants/actorType';
import { Config as movementConfig } from './objectData/movementConfig';

export const kittenAssetConfig = {
  NAME: 'KITTEN',
  ACTORTYPE: actorType.OBJECT,
  DATA: [movementConfig],
  TYPE: gameImportType.SPRITESHEET,
  SPRITESHEET_FOLDER: 'kitten',
  SPRITESHEET_NAME: 'Kitten-Sprite-Map-',
  INVENTORY: {
    [bodyPart.MOUTH]: [],
    [bodyPart.NECK]: [],
  },
  AUDIO: {},
  SCALE: 0.6,
  HEIGHT: 800,
  WIDTH: 800,
};
